import { Box, Fieldset, Grid, Select, Text } from '@mantine/core';
import { Control, Controller } from 'react-hook-form';
import useGetCompanies from '../../../../../../shared/hook/queries/useGetCompanies';
import type { Device, IRegModlinkFormValues } from '../../../../../../shared/types/device';

interface IClientInfoFormProps {
  control: Control<IRegModlinkFormValues>;
  data: Device | undefined;
}

export default function ClientInfoForm(props: IClientInfoFormProps) {
  const { control, data } = props;
  const isDisabled = !!data?.shipment;
  const { data: companies } = useGetCompanies({
    page: 1,
  });

  return (
    <Fieldset
      styles={(theme) => ({
        legend: {
          fontSize: theme.fontSizes.lg,
          fontWeight: 600,
          marginBottom: 0,
        },
      })}
      legend="납품처 정보 입력"
      variant="unstyled"
    >
      <Text size="xs" mb="xs" c="dimmed">
        [통합 관리 &gt; 거래처] 에서 거래처 등록은 먼저 진행해주세요.
      </Text>
      <Grid>
        <Grid.Col span={6}>
          <Box data-field="distributorCompany">
            <Controller
              name="distributorCompany"
              control={control}
              render={({ field, fieldState }) => (
                <Select
                  {...field}
                  key={field.value}
                  withAsterisk
                  searchable
                  label="거래처명"
                  description={
                    <Text size="xs" c="blue">
                      이미 출고된 디바이스는 거래처 변경에 유의해주세요.
                    </Text>
                  }
                  placeholder="거래처를 선택하세요."
                  data={companies?.data.map((company) => ({
                    value: company.id.toString(),
                    label: company.name,
                  }))}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Box>
        </Grid.Col>
      </Grid>
    </Fieldset>
  );
}
